import { useQuery } from '@tanstack/react-query'
import { hole } from '../lib/api'
import type { MitgliedKurz } from '../lib/modelle'
import { mitgliedsFarbe } from '../session/logic'
import { Avatar, Chip } from '../ui'

/**
 * Wer ist beteiligt? Eine Reihe antippbarer Namen.
 *
 * Kästchen wären hier die falsche Form: es geht nicht um eine Liste von
 * Bedingungen, sondern um Menschen — und die tragen ihre Farbe mit.
 */
export function PersonenAuswahl({
  wert,
  setzen,
}: {
  wert: string[]
  setzen: (wert: string[]) => void
}) {
  const personen = useQuery({
    queryKey: ['members'],
    queryFn: () => hole<MitgliedKurz[]>('/api/members'),
  })
  const aktive = (personen.data ?? []).filter((p) => p.status === 'active')

  return (
    <fieldset className="feldgruppe">
      <legend>Personen</legend>
      {personen.isError ? (
        <p className="fehler" role="alert">
          Personen konnten nicht geladen werden.
        </p>
      ) : null}
      {aktive.length === 0 ? (
        <p className="unterzeile">Noch niemand angelegt.</p>
      ) : (
        <div className="chips">
          {aktive.map((p) => (
            <Chip
              key={p.id}
              gewaehlt={wert.includes(p.id)}
              onClick={() => {
                setzen(
                  wert.includes(p.id) ? wert.filter((id) => id !== p.id) : [...wert, p.id],
                )
              }}
            >
              <Avatar name={p.displayName} farbe={mitgliedsFarbe(p.color, p.id)} klein />
              {p.displayName}
            </Chip>
          ))}
        </div>
      )}
    </fieldset>
  )
}
